"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _compact = _interopRequireDefault(require("lodash/compact"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _get = _interopRequireDefault(require("lodash/get"));

var _union = _interopRequireDefault(require("lodash/union"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _last = _interopRequireDefault(require("lodash/last"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _spacing = _interopRequireDefault(require("@decisiv/design-tokens/lib/spacing"));

var _Question = _interopRequireDefault(require("@decisiv/iconix/lib/components/Question"));

var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _InputField = _interopRequireDefault(require("../../atoms/InputField"));

var _useClickOutside = _interopRequireDefault(require("../../utils/useClickOutside"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _useUniqueId = _interopRequireDefault(require("../../utils/useUniqueId"));

var _Badge = _interopRequireDefault(require("../Badge"));

var _DropdownList = _interopRequireDefault(require("../DropdownList"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _Typography = require("../Typography");

var _useCombobox2 = _interopRequireDefault(require("./hooks/useCombobox"));

var _Target = _interopRequireDefault(require("./Target"));

var _schema = _interopRequireDefault(require("./schema"));

var _utils = require("./utils");

var _usePrevious = _interopRequireDefault(require("../../utils/usePrevious"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var StyledInputDiv = _styledComponents.default.div.withConfig({
  displayName: "Combobox__StyledInputDiv",
  componentId: "zvfxxj-0"
})(["position:relative;width:100%;max-width:", ";"], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return maxWidth;
});

function Combobox(props, ref) {
  var clearButtonLabel = props.clearButtonLabel,
      defaultValue = props.defaultValue,
      id = props.id,
      inputContainerRef = props.inputContainerRef,
      label = props.label,
      loading = props.loading,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? '100%' : _props$maxWidth,
      multiple = props.multiple,
      name = props.name,
      onChangeValue = props.onChangeValue,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onHide = props.onHide,
      onKeyDown = props.onKeyDown,
      onShow = props.onShow,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      renderOptionLabel = props.renderOptionLabel,
      propValue = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'sync' : _props$variant,
      zIndex = props.zIndex,
      containerSelector = props.containerSelector;

  var _useCombobox = (0, _useCombobox2.default)(props),
      getInputFieldProps = _useCombobox.getInputFieldProps,
      internalInputValue = _useCombobox.internalInputValue,
      setInternalInputValue = _useCombobox.setInternalInputValue;

  var translate = (0, _useTranslations.default)();
  var fallbackComboboxRef = (0, _react.useRef)(null);
  var finalComboboxRef = ref || fallbackComboboxRef;
  var inputId = (0, _useUniqueId.default)(id, 'combobox-');
  var listRef = (0, _react.useRef)(null);

  var _useBreakpointObserve = (0, _breakpointObserver.useBreakpointObserver)(),
      _useBreakpointObserve2 = _slicedToArray(_useBreakpointObserve, 2),
      popoverTargetRef = _useBreakpointObserve2[0],
      dimensions = _useBreakpointObserve2[1].dimensions;

  var inputContainerRefs = (0, _compact.default)([inputContainerRef, popoverTargetRef]);
  var finalInputContainerRef = inputContainerRefs.length > 1 ? _composeReactRefs.default.apply(void 0, _toConsumableArray(inputContainerRefs)) : (0, _get.default)(inputContainerRefs, 0);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      activeId = _useState2[0],
      setActiveId = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isPopoverVisible = _useState6[0],
      setIsPopoverVisibleState = _useState6[1];

  var previousIsPopoverVisible = (0, _usePrevious.default)(isPopoverVisible);
  /**
   * Combobox controls the Popover instead of relying on the Popover's internal state.
   * The Popover's onShow/ onHide handlers only function when the Popover is _not_
   * controlled. This effect watches for a toggled visibility state, and calls the appropriate
   * event handler.
   */

  (0, _react.useEffect)(function () {
    if (previousIsPopoverVisible && !isPopoverVisible && onHide) {
      onHide();
    }

    if (!previousIsPopoverVisible && isPopoverVisible && onShow) {
      onShow();
    }
  }, [isPopoverVisible, previousIsPopoverVisible, onShow, onHide]);
  /**
   * Update the dropdown list visibility.
   */

  var updateIsPopoverVisible = (0, _react.useCallback)(function (arg) {
    if (arg === true || arg === false) setIsPopoverVisibleState(arg);
    if (arg === 'toggle') setIsPopoverVisibleState(function (old) {
      return !old;
    });
  }, [setIsPopoverVisibleState]);
  /**
   * This generates a flat list of the options (including those in categories)
   * in the order they are presented in the dropdown list. Filtering disabled elements.
   */

  var flatOptions = (0, _react.useMemo)(function () {
    return options.reduce(function (acc, curr) {
      if ((0, _utils.isCategory)(curr)) {
        var items = (0, _isArray.default)(curr.items) ? curr.items.filter(function (option) {
          return !option.disabled;
        }) : [];
        return acc.concat(items);
      }

      if (!curr.disabled) {
        return acc.concat(curr);
      }

      return acc;
    }, []);
  }, [options]);
  (0, _react.useEffect)(function () {
    // Set the "default" active ID to the first in flatOptions, if it exists.
    if (!(0, _isEmpty.default)(flatOptions) && !activeId) {
      setActiveId((0, _get.default)(flatOptions, '0.id'));
    } // For async comboboxes, if the input is focused, the dropdown should be open.


    if (isFocused && variant === 'async' || multiple && internalInputValue !== '') {
      updateIsPopoverVisible(true);
    }
  }, [activeId, isFocused, flatOptions, variant, multiple, internalInputValue, updateIsPopoverVisible]); // The selectedValue is the id of the selectedOption, or an empty string if none selected.

  var _useState7 = (0, _react.useState)(!Array.isArray(propValue) && propValue || !Array.isArray(defaultValue) && defaultValue || undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedValue = _useState8[0],
      setSelectedValue = _useState8[1];

  var _useState9 = (0, _react.useState)(Array.isArray(propValue) && propValue || undefined),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedValues = _useState10[0],
      setSelectedValues = _useState10[1];
  /**
   * The current selected value and current input value are saved independently,
   * but must be kept in sync. Using a single callback for this keeps it simple(r).
   */


  var updateSelected = (0, _react.useCallback)(function (selectedId) {
    setSelectedValue(selectedId);
    var newSelected = (0, _utils.getOptionFromOptions)(options, selectedId) || null;

    if (multiple) {
      var index = selectedValues && selectedValues.findIndex(function (_ref2) {
        var itemId = _ref2.id;
        return itemId === selectedId;
      });

      if (newSelected && (index === undefined || index === -1)) {
        setSelectedValues((0, _union.default)(selectedValues, [newSelected]));
      }

      setInternalInputValue('');
      setActiveId(undefined);
    } else {
      setInternalInputValue((0, _get.default)(newSelected, 'label', ''));
    }

    if (onChangeValue) {
      if (selectedId) {
        onChangeValue(selectedId, {
          removed: false
        });
      } else {
        onChangeValue(null, {
          removed: true
        });
      }
    }
  }, [multiple, onChangeValue, options, selectedValues, setInternalInputValue, setSelectedValue, setSelectedValues, setActiveId]);
  var removeSelected = (0, _react.useCallback)(function (selectedId) {
    var newSelectedValues = selectedValues && selectedValues.filter(function (_ref3) {
      var optionId = _ref3.id;
      return selectedId !== optionId;
    });
    setSelectedValues(newSelectedValues);

    if (onChangeValue) {
      onChangeValue(selectedId, {
        removed: true
      });
    }

    return undefined;
  }, [onChangeValue, selectedValues, setSelectedValues]);
  /**
   * If the value prop changes, it should always override any locally maintained current values.
   * This allows the component to be controlled.
   */

  (0, _react.useEffect)(function () {
    if (typeof propValue === 'string' && propValue !== selectedValue) {
      setSelectedValue(propValue);
      var newSelected = (0, _utils.getOptionFromOptions)(options, propValue) || {};
      setInternalInputValue((0, _get.default)(newSelected, 'label', ''));
    } else if (_typeof(propValue) === 'object' && propValue !== selectedValues) {
      setSelectedValues(propValue);
    }
  }, [options, propValue, selectedValue, selectedValues, setInternalInputValue, updateSelected]);
  /**
   * This handler is called when the "active" item is changed in the DropdownList. That could be
   * when the user hovers over a new item with the mouse, or when the user navigates through
   * them with the keys.
   */

  var handleChangeDropdownListActiveItem = (0, _react.useCallback)(function (newActiveId) {
    setActiveId(newActiveId);
  }, [setActiveId]);
  /**
   * This handler is called by the dropdown's "onChange" event. That handler is called with
   * an array of values, but we only allow single select in the Combobox.
   */

  var handleChangeDropdownListValue = (0, _react.useCallback)(function (selectedIds) {
    if (multiple) {
      updateSelected((0, _last.default)(selectedIds));
      return;
    }

    updateSelected(selectedIds[0]);
  }, [updateSelected, multiple]);
  /**
   * Clicking anywhere within the Combobox component (except the clear button) should open
   * the dropdown list. There is some complex logic here because of the <input> rendered inside
   * the InputField. Basically, clicking on the <input> will call both this handler & onFocus,
   * resulting in a "double toggle" of the popover's visibility.
   *
   * There is additional logic due to React's bubbling of synthetic events.
   */

  var handleContainerClick = (0, _react.useCallback)(function (event) {
    if (finalInputContainerRef && // @ts-ignore
    !finalInputContainerRef.current.contains(event.target)) {
      /**
       * The dropdown list is _not_ a direct descendant of the input container in the DOM.
       * The dropdown list _is_ a direct descendant of the input container in React. Since
       * React's events are Synthetic, they bubble up through the React tree, _not_ the DOM
       * tree. Clicking an item in the list will call this click handler on the container.
       * Usually that's fine. In this case, we don't want that behavior.
       */
      updateIsPopoverVisible(false);
    } else if (isFocused) {
      if (variant === 'sync' && finalComboboxRef && // @ts-ignore
      finalComboboxRef.current === event.target) {
        /**
         * This prevents a double toggle when the user clicks
         * the actual input field inside the combobox.
         */
        event.preventDefault();
        event.stopPropagation();

        if (!isPopoverVisible) {
          /**
           * This re-opens the popover if you first open it,
           * then make a selection, then click the <input> again.
           */
          updateIsPopoverVisible(true);
        }
      } else {
        updateIsPopoverVisible('toggle');
      }
    }

    onClick && onClick(event);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [isFocused, isPopoverVisible, variant, onClick, updateIsPopoverVisible]);
  /**
   * This focus handler is responsible for opening the dropdown list and tracking focus state.
   * It's important to do this in the focus handler because the dropdown should open when the
   * Combobox is clicked or tabbed to.
   */

  var handleContainerFocus = (0, _react.useCallback)(function (event) {
    if (variant === 'sync') {
      updateIsPopoverVisible(true);
    }

    setIsFocused(true);
    onFocus && onFocus(event);
  }, [onFocus, updateIsPopoverVisible, variant]);
  /**
   * Pressing certain keys when focused on the Combobox component should trigger some actions.
   */

  var handleContainerKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      // Blocks the up/down nav inside the input field, which is unexpected when navigating
      // through the options in the dropdown.
      event.preventDefault();

      if (!isPopoverVisible) {
        updateIsPopoverVisible(true);
      } else {
        var currentIndex = (0, _findIndex.default)(flatOptions, function (_ref4) {
          var optionId = _ref4.id;
          return optionId === activeId;
        });

        if (event.key === 'ArrowDown') {
          var newIndex = currentIndex + 1 >= flatOptions.length ? currentIndex : currentIndex + 1;
          var newActiveId = (0, _get.default)(flatOptions[newIndex], 'id');
          setActiveId(newActiveId);
        }

        if (event.key === 'ArrowUp') {
          var _newIndex = currentIndex - 1 <= 0 ? 0 : currentIndex - 1;

          var _newActiveId = (0, _get.default)(flatOptions[_newIndex], 'id');

          setActiveId(_newActiveId);
        }
      }
    }

    if (event.key === 'Enter' && isPopoverVisible) {
      updateSelected(activeId || '');
      updateIsPopoverVisible(false);
    }

    if (event.key === 'Escape') {
      updateIsPopoverVisible(false);
    }

    if (event.key === 'Tab' && isPopoverVisible) {
      updateIsPopoverVisible(false);
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  }, [activeId, flatOptions, isPopoverVisible, onKeyDown, updateIsPopoverVisible, updateSelected]); // When the dropdown is visible, clicking anywhere outside of the dropdown should close it.

  var handleClickOutsideList = (0, _react.useCallback)(function (event) {
    if (isPopoverVisible) {
      updateIsPopoverVisible(false);
    }
  }, [isPopoverVisible, updateIsPopoverVisible]);
  (0, _useClickOutside.default)([finalComboboxRef, listRef], handleClickOutsideList);
  /**
   * The DropdownList accepts a prop called `PanelComponent` that can be used
   * to render useful messages like "Loading" and "No Matches". This builds those
   * messages.
   */

  var getPanelComponent = (0, _react.useCallback)(function () {
    if (loading) {
      return function () {
        return _react.default.createElement(_Grid.default.Container, {
          paddingY: 1
        }, _react.default.createElement(_Grid.default.Row, {
          alignment: "center",
          paddingY: 1
        }, _react.default.createElement(_Grid.default.Column, {
          maxWidth: (0, _rem.default)(_spacing.default.base * 22)
        }, _react.default.createElement(_Typography.H4, null, translate(undefined, 'combobox.loading')))));
      };
    }

    if (internalInputValue && (0, _isEmpty.default)(options)) {
      return function () {
        return _react.default.createElement(_Grid.default.Container, {
          paddingY: 1
        }, _react.default.createElement(_Grid.default.Row, {
          alignment: "center",
          paddingY: 1
        }, _react.default.createElement(_Grid.default.Column, {
          maxWidth: (0, _rem.default)(_spacing.default.base * 22)
        }, _react.default.createElement(_Grid.default.Row, {
          alignment: "center"
        }, _react.default.createElement(_Grid.default.Column, null, _react.default.createElement(_Badge.default, {
          "aria-label": "",
          color: 'licoriceMousse',
          icon: _Question.default
        }))), _react.default.createElement(_Typography.H4, {
          paddingY: 1
        }, translate(undefined, 'combobox.noMatches')), _react.default.createElement(_Typography.P, {
          shade: 1
        }, translate(undefined, 'combobox.noMatchesMessage')))));
      };
    }

    return undefined;
  }, [internalInputValue, loading, options, translate]);
  var selectedValuesIds = selectedValues ? selectedValues.map(function (elem) {
    return elem && elem.id || '';
  }) : undefined;
  return _react.default.createElement(StyledInputDiv, {
    maxWidth: maxWidth
  }, _react.default.createElement(_InputField.default, _extends({}, getInputFieldProps(), {
    id: inputId,
    inputContainerRef: finalInputContainerRef,
    onBlur: function onBlur() {
      setIsFocused(false);
    },
    onFocus: handleContainerFocus,
    onClick: handleContainerClick,
    onKeyDown: handleContainerKeyDown,
    ref: finalComboboxRef
  }), function (_ref5) {
    var ariaLabelledBy = _ref5['aria-labelledby'],
        disabled = _ref5.disabled,
        targetId = _ref5.id,
        onBlurTarget = _ref5.onBlur,
        onChangeTargetValue = _ref5.onChange,
        onFocusTarget = _ref5.onFocus,
        readOnly = _ref5.readOnly,
        targetRef = _ref5.ref,
        value = _ref5.value,
        autoComplete = _ref5.autoComplete,
        type = _ref5.type;
    var dropdownListId = "".concat(targetId, "-dropdown-list");
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Target.default, {
      "aria-haspopup": "listbox",
      "aria-labelledby": "".concat(ariaLabelledBy, " ").concat(targetId),
      "aria-owns": dropdownListId,
      clearButtonLabel: clearButtonLabel,
      disabled: disabled,
      hasClearButton: Boolean(value),
      id: targetId,
      inputFieldLabel: label,
      isPopoverVisible: isPopoverVisible,
      name: name,
      multiple: multiple,
      selectedValues: selectedValues,
      removeSelected: removeSelected,
      onBlur: onBlurTarget,
      onClear: function onClear() {
        onChangeTargetValue();
        updateSelected();
      },
      onChange: onChangeTargetValue,
      onFocus: onFocusTarget,
      readOnly: readOnly,
      ref: targetRef,
      value: value,
      variant: variant,
      toggleIsPopoverVisible: function toggleIsPopoverVisible() {
        return updateIsPopoverVisible('toggle');
      },
      autoComplete: autoComplete,
      type: type
    }), _react.default.createElement(_DropdownList.default, {
      containerSelector: containerSelector,
      PanelComponent: getPanelComponent(),
      activeId: activeId,
      "aria-labelledby": ariaLabelledBy,
      borderRadius: "0",
      defaultActiveId: activeId,
      focusOnShowing: false,
      id: dropdownListId,
      items: options,
      listRef: listRef,
      minWidth: "".concat((dimensions.width || 0) + 1, "px"),
      name: "".concat(name, "_dropdown-list"),
      multiple: multiple,
      onChange: handleChangeDropdownListValue,
      onChangeActiveItem: handleChangeDropdownListActiveItem,
      selectedIds: !multiple ? selectedValue || '' : selectedValuesIds,
      showArrow: false,
      showCheckbox: !multiple,
      target: popoverTargetRef,
      visible: Boolean(isPopoverVisible || loading),
      renderOptionLabel: renderOptionLabel,
      zIndex: zIndex
    }));
  }));
}

var ComboboxWithRef = (0, _react.forwardRef)(Combobox);
ComboboxWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  icon: _propTypes.default.elementType
});
var _default = ComboboxWithRef;
exports.default = _default;